import { TopDomainsPanel } from './shared/TopDomainsPanel';

export function SourcesDomainsPage() {
  return (
    <div className="space-y-4">
      <TopDomainsPanel limit={50} />
    </div>
  );
}
